// @flow

import React from 'react';
import { colors } from 'seedling/constants';
import styled from 'styled-components';

type Props = {
  color: 'string',
  hoverColor: 'string',
  className: 'string',
  height: number,
  width: number,
};

const ellipsisSvg = ({ color, height, width, className }: Props) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 6">
    <g fill={color} fillRule="evenodd">
      <ellipse cx="2.735" cy="2.739" rx="2.735" ry="2.739" />
      <path d="M11.853 5.478c1.51 0 2.735-1.226 2.735-2.74C14.588 1.227 13.364 0 11.853 0c-1.51 0-2.735 1.226-2.735 2.74 0 1.512 1.224 2.738 2.735 2.738z" />
      <ellipse cx="20.971" cy="2.739" rx="2.735" ry="2.739" />
    </g>
  </svg>
);

// $FlowFixMe
const Ellipsis = styled(ellipsisSvg)`
  cursor: pointer;

  &:hover {
    g {
      fill: ${props => props.hoverColor};
    }
  }
`;

Ellipsis.displayName = 'Ellipsis';

Ellipsis.defaultProps = {
  color: colors.mediumGrey,
  hoverColor: colors.darkestGrey,
  height: 6,
  width: 24,
};

export default Ellipsis;
